import { render } from "./SigninForm.vue?vue&type=template&id=54cd1cae&scoped=true"
import script from "./SigninForm.vue?vue&type=script&lang=js"
export * from "./SigninForm.vue?vue&type=script&lang=js"

import "./SigninForm.vue?vue&type=style&index=0&id=54cd1cae&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cd1cae"]])

export default __exports__